import styled from 'styled-components';

import { SYS_BREAKPOINT_MD, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_350 } from '@oneaudi/unified-web-alpha-common';

export const ConsumptionAndEmissionTextStyle = styled.div<{ $withoutPadding?: boolean }>`
	width: 100%;
	height: max-content;
	min-height: 3rem;

	padding: ${SYS_SPACE_FIXED_150};

	@media screen and (min-width: ${SYS_BREAKPOINT_MD}) {
		padding-left: ${SYS_SPACE_FIXED_350};
		padding-right: ${SYS_SPACE_FIXED_350};
	}

	${({ $withoutPadding }) => $withoutPadding && 'padding: 0 !important'};

	.text-wrapper {
		display: inline;

		.entry-wrapper {
			display: inline;
			sup {
				font-size: 0.583em;
			}
		}
	}
`;
